export const NAV_DATA = [
  {
    id: 1,
    icon: <i className="icon-target"></i>,
    tittle: "All",
  },
  {
    id: 2,
    icon: <i className="icon-image"></i>,
    tittle: "Images",
  },
  {
    id: 3,
    icon: <i className="icon-video-clapper"></i>,
    tittle: "Videos",
  },
  {
    icon: <i className="icon-map-alt"></i>,
    tittle: "Audios",
  },
  {
    tittle: "Settings",
    navItemClass:"bg-light-success",
  },
  {
    tittle: "Tools",
    navItemClass:"bg-light-secondary",
  },
];

export const SEARCH_TAB_DATA = [
  {
    id: 1,
    title: "PixelStrap - Portfolio | ThemeForest",
    url: "https://themeforest.net/user/pixelstrap/portfolio/",
    detail:
      "2023's best selling creative wp themes. the #1 source of premium wp themes! themeforest 45,000+ wp themes & website templates from $2. check it out!",
    star: "3 stars",
    vote: "590 votes",
    news: "Theme",
    videoLink: "https://www.youtube.com/embed/CJnfAXlBRTE",
  },
  {
    id: 2,
    title: "PixelStrap - Portfolio | ThemeForest",
    url: "PixelStrap - Portfolio | ThemeForestthemeforest.net › user ›",
    detail:
      "the #1 marketplace for premium website templates, including themes for wordpress, magento, drupal, joomla, and more. create a website, fast.",
    star: "3 stars",
    vote: "590 votes",
    news: "Theme",
    videoLink: "https://www.youtube.com/embed/wpmHZspl4EM",
  },
  {
    id: 3,
    title: "Morbi feugiat mauris vel semper fringilla.",
    url: "https://themeforest.net/user/pixelstrap/portfolio",
    detail:
      "cuba introduces a ielts coaching, toefl coaching, gre coaching, gmat coaching, sat coaching in surat.",
    star: "3 stars",
    vote: "590 votes",
    news: "Theme",
    videoLink: "https://www.youtube.com/embed/-L4gEk7cOfk",
    showStar: [true, true, true, false, false],
  },
  {
    id: 4,
    title: "Morbi feugiat mauris vel semper fringilla.",
    url: "https://themeforest.net/user/pixelstrap/portfolio",
    detail:
      "cuba introduces a ielts coaching, toefl coaching, gre coaching, gmat coaching, sat coaching in surat.",
    star: "3 stars",
    vote: "590 votes",
    news: "Theme",
    videoLink: "https://www.youtube.com/embed/CJnfAXlBRTE",
    showStar: [true, true, false, false, false],
  },
];

export const SEARCH_INFORMATION = {
  title: "Morbi feugiat mauris vel semper fringilla.",
  url: "https://themeforest.net/user/pixelstrap/portfolio",
  detail:
    "get 59 pixelstrap website templates on themeforest. buy pixelstrap website templates from $7. all created by our global community of independent web ...",
  star: "3 stars",
  vote: "590 votes",
  news: "Theme",
  videoLink: "https://www.youtube.com/embed/wpmHZspl4EM",
  showStar: [true, true, false, false, false],
};

export const SEARCH_INFORMATION_TWO = {
  title: "Morbi feugiat mauris vel semper fringilla.",
  url: "https://themeforest.net/user/pixelstrap/portfolio",
  detail:
    "cuba introduces a ielts coaching, toefl coaching, gre coaching, gmat coaching, sat coaching in surat.",
  star: "3 stars",
  vote: "590 votes",
  news: "Theme",
  videoLink: "https://www.youtube.com/embed/wpmHZspl4EM",
  showStar: [true, true, false, false, false],
};

export const SEARCH_IMAGE_PATH = [
  "big-lightgallry/01.jpg",
  "big-lightgallry/02.jpg",
  "big-lightgallry/03.jpg",
  "big-lightgallry/04.jpg",
  "big-lightgallry/05.jpg",
  "big-lightgallry/06.jpg",
  "big-lightgallry/07.jpg",
  "big-lightgallry/08.jpg",
  "big-lightgallry/09.jpg",
  "big-lightgallry/010.jpg",
  "big-lightgallry/011.jpg",
  "big-lightgallry/012.jpg",
];